import type { GeneratedFileTemplate } from "schemas/generated/fileTemplate";

import React from "react";

import { useWebContainerTemplate } from "./useWebContainerTemplate";

interface WebContainerTemplateProps {
  template: GeneratedFileTemplate;
  enabled?: boolean;
  children?: (params: {
    templateRoute: string;
    isInserted: boolean;
  }) => React.ReactNode;
}

/**
 * Component that manages a single template's lifecycle in the webcontainer.
 * Inserts the template on mount and removes it on unmount.
 * Uses render props to provide the template route and insertion status to children.
 */
export function WebContainerTemplate({
  template,
  enabled = true,
  children,
}: WebContainerTemplateProps) {
  const { isInserted, templateRoute } = useWebContainerTemplate({
    template,
    enabled,
  });

  return <>{children?.({ templateRoute, isInserted })}</>;
}
